import PurchaseCoins from './PurchaseCoins';

export default PurchaseCoins;
